export default "__VITE_ASSET__BHUPQJEX__"